import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { PrivateStackParamList, PublicStackParamList } from '@routes/types';

// Define a type for the slice state
interface ErrorState {
    showErrorHeading?: boolean,  
    btnName?:string | null,
    isErrorSheetVisible: boolean,
    closeOnBackdropPress: boolean,
    errorType: any,
    errorMessage?: string | null,
    errorHeading?: string | null,
    routeName? : keyof PrivateStackParamList | keyof PublicStackParamList | undefined,
    ctaLabel?: string | null,
    ctaAction?: () => void
    showMsgBg?: boolean
    isWarning?: boolean
}

// Define the initial state using that type
const initialState : ErrorState = {
    btnName:null,
    showErrorHeading: true,  
    isErrorSheetVisible: false,
    closeOnBackdropPress: false,
    errorType: null,
    errorMessage: null,
    errorHeading:null,
    showMsgBg: true,
    isWarning: false,
    ctaLabel: null,
    ctaAction: undefined
  };

export const errorSlice = createSlice({
  name: 'errorSheet',
  initialState,
  reducers: {
    showErrorSheet: (state , action : PayloadAction<ErrorState>) => {
        state.isErrorSheetVisible = true
        state.closeOnBackdropPress = action.payload.closeOnBackdropPress
        state.errorType = action.payload.errorType
        state.errorMessage =action.payload.errorMessage
        state.errorHeading =action.payload.errorHeading || null
        state.routeName = action.payload.routeName ?? undefined
        state.showErrorHeading = action.payload.showErrorHeading ?? true
        state.btnName = action?.payload?.btnName ?? '';
        state.showMsgBg = action.payload.showMsgBg ?? true
        state.isWarning= action.payload.isWarning ?? false

        state.ctaLabel = action.payload.ctaLabel ?? null
        state.ctaAction = action.payload.ctaAction ?? undefined
    },
    hideErrorSheet: (state) => {
        state.isErrorSheetVisible = false
        state.closeOnBackdropPress = false
        state.errorType = null
        state.errorMessage = null
        state.errorHeading = null
        state.routeName = undefined
        state.showErrorHeading = true
        state.btnName = ""
        state.showMsgBg = false
        state.isWarning = false
    },
  },
})

export const { showErrorSheet, hideErrorSheet } = errorSlice.actions


export default errorSlice.reducer